/* BERACAH v2 – light interactions. Upload to Assets > beracah.js
   1. header shadow on scroll   2. fade-up reveal   3. slider arrows + dots
   4. video band: play only when visible, pause/mute buttons (respects reduced motion) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Header shadow */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var onScroll = function () { header.classList.toggle('beracah-is-scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* 2. Reveal on scroll */
  var items = document.querySelectorAll('.beracah-reveal');
  if (items.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      items.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 90 + 'ms'; io.observe(el); });
    }
  }

  /* 3. Sliders: <div data-bz-slider> .bz-track > .bz-slide, [data-bz-prev], [data-bz-next], [data-bz-dots] */
  document.querySelectorAll('[data-bz-slider]').forEach(function (root) {
    var track = root.querySelector('.bz-track');
    if (!track) return;
    var slides = track.querySelectorAll('.bz-slide');
    var prev = root.querySelector('[data-bz-prev]');
    var next = root.querySelector('[data-bz-next]');
    var dotsBox = root.querySelector('[data-bz-dots]');
    var dots = [];

    function go(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    if (dotsBox && slides.length > 1) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); });
        dotsBox.appendChild(b);
        dots.push(b);
      });
    }
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  });

  /* 4. Video band */
  document.querySelectorAll('[data-bz-video]').forEach(function (root) {
    var v = root.querySelector('video');
    if (!v) return;
    var pauseBtn = root.querySelector('[data-bz-pause]');
    var muteBtn = root.querySelector('[data-bz-mute]');
    var userPaused = reduce; /* reduced-motion users start paused */

    function setPauseUI() {
      if (!pauseBtn) return;
      var paused = v.paused;
      pauseBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      pauseBtn.querySelector('.i-pause').classList.toggle('is-hidden', paused);
      pauseBtn.querySelector('.i-play').classList.toggle('is-hidden', !paused);
    }
    function setMuteUI() {
      if (!muteBtn) return;
      muteBtn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
      muteBtn.querySelector('.i-muted').classList.toggle('is-hidden', !v.muted);
      muteBtn.querySelector('.i-sound').classList.toggle('is-hidden', v.muted);
    }
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      if (v.paused) { userPaused = false; v.play(); } else { userPaused = true; v.pause(); }
      setPauseUI();
    });
    if (muteBtn) muteBtn.addEventListener('click', function () { v.muted = !v.muted; setMuteUI(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !userPaused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else if (!e.isIntersecting) v.pause();
          setPauseUI();
        });
      }, { threshold: 0.35 }).observe(root);
    } else if (!userPaused) { v.play(); }
    setPauseUI(); setMuteUI();
  });
})();
